<template>
  <span @click="facebookLink(url)">
    <i class="fa fa-facebook fa-2x" style="color:#3B5998" :scale="scale"></i>
  </span>
</template>

<script>
import objectToGetParams from "../utils/objectToGetParams";
export default {
  name: "facebook",
  methods: {
    facebookLink(url) {
      window.open(
        `https://www.facebook.com/sharer/sharer.php` +
          objectToGetParams({
            u: url
          }),
        "__blank"
      );
    }
  },
  props: {
    url: {
      required: true,
      type: String
    },
    scale: {
      required: false,
      type: String
    }
  }
};
</script>
